import { render } from "./OptionLayer.vue?vue&type=template&id=5f2e99e4"
import script from "./OptionLayer.vue?vue&type=script&lang=js"
export * from "./OptionLayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__